import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  RowPriceRequest,
  RowPriceResponse
} from '../../../models/row-price.model';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class RowPriceService {

  constructor(private http: HttpClient) {}

  /**
   * Calculates how many rows fulfill ALL selected properties and their price.
   *
   * @param tableName  logical table id (ends with “…_de”)
   * @param states     Bundesländer or ["total"]
   * @param properties list of selected properties (checkbox values)
   * @param max maximum number of acceptable Results
   */
  getRowCountAndPrice(
      tableName: string,
      states: string[],
      properties: string[],
      max: number,
  ): Observable<RowPriceResponse> {

    const url  = `${environment.apiUrl}/tables/row-price`;
    const body: RowPriceRequest = { tableName, states, properties, max };
    return this.http.post<RowPriceResponse>(url, body).pipe(
        catchError(this.handleError)
    );
  }

  // quick local fallback – replace with global interceptor if you have one
  private handleError(err: HttpErrorResponse) {
    console.error('Row-price request failed', err);
    return throwError(() =>
        new Error(err.error?.message || 'Row-price request failed.'));
  }
}